module.exports = __webpack_public_path__ + "02_long_gray.ccfe3df3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_long_gray.png
// module id = /C4E
// module chunks = 0